export const LOGIN_TOKEN_KEY = 'login_token';
export const LOGIN_USER_INFO = 'login_user_info';
